import { MlModal } from '@/components/molecules';
import {
  IModalRefProps,
  EModalVariants,
} from '@/components/molecules/ml-modal/ml-modal.types';
import { useState } from 'react';
import {
  IAdvancedFiltersModalProps,
  AdvancedFilterVals,
  RangeKey,
} from '../types';
import { zeroOr } from '../utils';
import { AdvancedFiltersBody } from './AdvancedFiltersBody';

export const AdvancedFiltersModal = ({
  modalRef,
  configData,
  filterValues,
  setFilter,
  scrollListData,
}: IAdvancedFiltersModalProps) => {
  const [local, setLocal] = useState<AdvancedFilterVals>({
    MinDepth: '',
    MaxDepth: '',
    MinWidth: '',
    MaxWidth: '',
  });

  const hydrate = () => {
    setLocal({
      MinDepth: String(filterValues.MinDepth ?? ''),
      MaxDepth: String(filterValues.MaxDepth ?? ''),
      MinWidth: String(filterValues.MinWidth ?? ''),
      MaxWidth: String(filterValues.MaxWidth ?? ''),
    });
  };
  const resetLocal = () => {
    setLocal({ MinDepth: '', MaxDepth: '', MinWidth: '', MaxWidth: '' });
  };

  const handleChange = (key: RangeKey, value: string) => {
    setLocal((prev) => ({ ...prev, [key]: value }));
  };

  const onApply = () => {
    setFilter('MinDepth', zeroOr(local.MinDepth));
    setFilter('MaxDepth', zeroOr(local.MaxDepth));
    setFilter('MinWidth', zeroOr(local.MinWidth));
    setFilter('MaxWidth', zeroOr(local.MaxWidth));

    (modalRef as React.RefObject<IModalRefProps>)?.current?.handleClose?.();
  };

  return (
    <MlModal
      ref={modalRef}
      onOpen={hydrate}
      onClose={resetLocal}
      variant={EModalVariants.LEAD_GEN}
    >
      <AdvancedFiltersBody
        scrollListData={scrollListData}
        values={local}
        configData={configData}
        onChange={handleChange}
        onApply={onApply}
      />
    </MlModal>
  );
};
